import { CREATE, GET_ONE, GET_LIST, GET_MANY, DELETE, DELETE_MANY, UPDATE, UPDATE_MANY } from 'ra-core';



export default async (type, resource, params) => {       
   
    return {type, resource, params};
};